import React from "react";

export function LinearIndeterminate() {
  return (
    <div className="relative w-full h-1 overflow-hidden bg-gray-200 rounded">
      <div className="absolute inset-0">
        <div className="linear-indeterminate-bar" />
      </div>
      <style jsx>{`
        .linear-indeterminate-bar {
          position: absolute;
          height: 100%;
          width: 100%;
          background: linear-gradient(90deg, #22d3ae 0%, #3b82f6 50%, #22d3ee 100%);
          animation: linear-indeterminate 1.5s infinite linear;
          background-size: 200% 100%;
        }
        @keyframes linear-indeterminate {
          0% {
            background-position: -100% 0;
          }
          100% {
            background-position: 100% 0;
          }
        }
      `}</style>
    </div>
  );
} 